import moment from 'moment'
import { amountDisplay, formatDateTime } from '../formats' // TODO: Remove barrel files from gdp-common
import { getOrdinal } from '../functions/numberFuncs'

export function generateInstalments({
  totalAmount = 0,
  startDate = new Date(),
  instalmentsCount = 4,
  instalmentsFrequency = 2,
  instalmentsDelay = 'weeks',
  firstInstalmentDueToday = true,
  currency = 'AUD',
  timezone = 'Australia/Melbourne',
  customFormatDate,
  customFormatCurrency,
  additionalFirstCharge = 0,
}) {
  if (totalAmount === 0 || instalmentsCount <= 1) {
    return []
  }

  const start = moment(startDate)

  const amountInCents = Math.round(totalAmount * 100)
  const baseAmount = Math.ceil(amountInCents / instalmentsCount)
  const remainderAmount = amountInCents - (instalmentsCount - 1) * baseAmount

  const amounts = []
  for (let i = 0; i < instalmentsCount - 1; i++) {
    amounts.push(baseAmount)
  }

  if (remainderAmount > 0) {
    amounts.push(remainderAmount)
  }

  const instalments = amounts.map((calculatedAmount, i) => {
    const number = i + 1
    const intervalNumber = i * instalmentsFrequency
    const ordinal = getOrdinal(number)

    let amountRaw = Math.round((calculatedAmount / 100 + Number.EPSILON) * 100) / 100

    if (i === 0 && additionalFirstCharge > 0) {
      amountRaw = amountRaw + additionalFirstCharge
    }

    const amount =
      typeof customFormatCurrency === 'function'
        ? customFormatCurrency(amountRaw, currency)
        : amountDisplay(amountRaw, currency, false)

    const dateRaw = start
      .clone()
      .add(instalmentsFrequency * i, instalmentsDelay)
      .toISOString()
    const date =
      typeof customFormatDate === 'function'
        ? customFormatDate(dateRaw, timezone)
        : formatDateTime({ value: dateRaw, style: 10, returnDateOnly: true, timezone })

    const title = `${ordinal} Instalment: `
    const description = `${firstInstalmentDueToday && number === 1 ? `Due Today on ${date}` : `Due in ${intervalNumber} ${instalmentsDelay} on ${date}`}`

    return {
      title,
      description,
      amount,
      date,
      number,
      ordinal,
      dateRaw,
      amountRaw,
    }
  })

  return instalments
}
